import { GenericBaseParameter } from '../base-parameter';

export interface ISmartSearchParameter { 
}
export class SmartSearchParameter extends GenericBaseParameter<ISmartSearchParameter> implements ISmartSearchParameter { }